import { DirectoryNameConsts, DirectoryTypeConsts } from 'client/util/Constants/DirectoryConstants';

// This is a collection of possible values for the `resource.type`.
export const resourceTypes = {
  system: 'system',
  application: 'application',
};

/**
 * This is a collection of possible values for the `association.connection.to.type` and
 * `association.connection.from.type` fields for association events.
 */
export const resourceValues = {
  activeDirectory: 'ACTIVE_DIRECTORY',
  application: 'APPLICATION',
  command: 'COMMAND',
  gSuite: 'G_SUITE',
  ldapServer: 'LDAP_SERVER',
  office365: 'OFFICE_365',
  policy: 'POLICY',
  policyGroup: 'POLICY_GROUP',
  radiusServer: 'RADIUS_SERVER',
  system: 'SYSTEM',
  systemGroup: 'SYSTEM_GROUP',
  user: 'USER',
  userGroup: 'USER_GROUP',
};

export default {
  resourceToGenericTextMap: {
    [resourceValues.activeDirectory]: `An ${DirectoryNameConsts[DirectoryTypeConsts.activeDirectory]}`,
    [resourceValues.application]: 'An application',
    [resourceValues.command]: 'A command',
    [resourceValues.gSuite]: `A ${DirectoryNameConsts[DirectoryTypeConsts.gSuite]} directory`,
    [resourceValues.ldapServer]: DirectoryNameConsts[DirectoryTypeConsts.ldapServer],
    [resourceValues.office365]: `An ${DirectoryNameConsts[DirectoryTypeConsts.office365]} directory`,
    [resourceValues.policy]: 'A policy',
    [resourceValues.policyGroup]: 'A policy group',
    [resourceValues.radiusServer]: 'A RADIUS server',
    [resourceValues.system]: 'A device',
    [resourceValues.systemGroup]: 'A device group',
    [resourceValues.user]: 'A user',
    [resourceValues.userGroup]: 'A user group',
  },

  // A map that converts a resource value to display text that can be shown to the customer
  resourceToTextMap: {
    [resourceValues.activeDirectory]: DirectoryNameConsts[DirectoryTypeConsts.activeDirectory],
    [resourceValues.application]: 'application',
    [resourceValues.command]: 'command',
    [resourceValues.gSuite]: DirectoryNameConsts[DirectoryTypeConsts.gSuite],
    [resourceValues.ldapServer]: DirectoryNameConsts[DirectoryTypeConsts.ldapServer],
    [resourceValues.office365]: DirectoryNameConsts[DirectoryTypeConsts.office365],
    [resourceValues.policy]: 'policy',
    [resourceValues.policyGroup]: 'policy group',
    [resourceValues.radiusServer]: 'RADIUS server',
    [resourceValues.system]: 'device',
    [resourceValues.systemGroup]: 'device group',
    [resourceValues.user]: 'user',
    [resourceValues.userGroup]: 'user group',
  },
};
